import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import '../css/modal.css';

import LoaderModal from './LoaderModal';

const UserObjectBox = ({ objectData, userId, token }) => {

  const [confirmModal, setConfirmModal] = useState(false);
  const [declineModal, setDeclineModal] = useState(false);
  const [isFetchPending, setIsFetchPending] = useState(false);
  const [isConfirmedRequest, setIsConfirmedRequest] = useState(false);
  const [isDeclinedRequest, setIsDeclinedRequest] = useState(false);

  //----- GESTISCO LE MODALI DI CONFERMA E ANNULLA RICHIESTA -----//

  const openConfirmModal = () => {
    setConfirmModal(true);
  }

  const closeConfirmModal = () => {
    setConfirmModal(false);
  }

  const openDeclinedModal = () => {
    setDeclineModal(true);
  }

  const closeDeclineModal = () => {
    setDeclineModal(false);
  }

  //-----//

  //----- CREO LE FETCH PER RIFIUTARE LA RICHIESTA -----//

    // UNPICK DELL'OGGETTO IN COLLECTION ROBA

  const declineRequest = async () => {
    setIsFetchPending(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/roba/unpick/${userId}/${objectData._id}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const unpickedObject = await response.json();
        console.log(unpickedObject);
        updatedExchange();
      } else {
        console.log('Error.', response)
        setIsDeclinedRequest(true);
      }
    } catch (error) {
      console.log('Error Type: ', error)
      setIsDeclinedRequest(true);
    }

  }

    // CAMBIO STATO IN "declined" NELLA COLLECTION EXCHANGE
    const updatedExchange = async () => {

      const newStatus = { status: 'declined' };
       try {

         const res = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/exchanges/changeStatus/${userId}/${objectData._id}`, {
           method: 'PATCH',
           headers: {
             Authorization: `Bearer ${token}`,
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(newStatus)
         });

         if (res.ok) {
           const updatedExchange = await res.json();
           console.log(updatedExchange);
           setIsDeclinedRequest(true);
         } else {
           console.log('Error: ', res);
         }
       } catch (error) {
         console.log('Error Type: ', error)
       }

       closeDeclineModal();
       setIsFetchPending(false);

    }

    //----- LA CONFERMA DELLO SCAMBIO MANDA A UNA PAGINA DEDICATA -----//

    const navigate = useNavigate();

    const goToConfirmExchange = () => {
      navigate(`/confirmExchange/${objectData._id}/${token}`)
    }

    //-----//


  //-----//

  return (
    <div className={objectData.picked.isPicked ? ('single-roba-object my-object-picked') : ('single-roba-object')}>
      {objectData.picked.isPicked && <div className="my-object-picked-alert">Hai una richiesta per questo oggetto!</div>}
      <div className="single-object-photo">
        <img src={objectData.photo.resizedUrl} />
      </div>
      <div className="single-object-info">
        <h3>{objectData.robaName}</h3>
        <h6>(Oggetto inserito il {objectData.createdAt})</h6>
        <label>Descrizione oggetto:</label><div className="object-description">{objectData.description}</div>
        <h5>{objectData.status}</h5>
        <label>Pensiero del proprietario dell'oggetto:</label>
        {
          objectData.stuffThought ? (
            <div className="object-description">{objectData.stuffThought}</div>
          ) : (
            <div className="object-description">---</div>
          )
        }

        {objectData.picked.isPicked && !confirmModal && !isDeclinedRequest &&
          <div className="confirm-request-modal-button">
            <button onClick={openConfirmModal}>Accetta la richiesta</button>
            <button onClick={openDeclinedModal}>Rifiuta la richiesta</button>
          </div>
        }
        {confirmModal &&

          <div className="confirm-request-modal">
            <h2>Confermi di voler <span style={{color: '#94A684'}}>ACCETTARE</span> la richiesta per questo oggetto?</h2>
            <p>Donerai questo oggetto al richiedente. Egli, in cambio, si impegnerà a venire a prenderlo quanto prima, permettendoti di liberartene senza troppe scocciature.</p>
            <h4>Questo sarà uno scambio equo. nessuno guadagna di più rispetto all'altro, non ci sono fini di lucro o speculativi.</h4>
            <p>Sei libero di non accettare la richiesta. In quel caso l'oggetto sarà rimesso in offerta insieme agli altri e potrai eliminarlo completamente in qualsiasi momento.</p>
            <h4>Nulla deve essere forzato, ROBA è creata per aiutarsi e contribuire insieme a ridurre gli sprechi.</h4>

            <div className="confirm-request-modal-button">
              <button onClick={goToConfirmExchange}>Accetto la richiesta</button>
              <button onClick={closeConfirmModal}>Torna indietro</button>
            </div>
          </div>

        }

        {declineModal &&

          <div className="confirm-request-modal">
            <h2>Confermi di voler <span style={{color: '#C63D2F'}}>RIFIUTARE</span> la richiesta per questo oggetto?</h2>
            <p>Rifiutando questa richiesta renderai l'oggetto di nuovo disponibile e sarai poi libero di eliminarlo.</p>
            <h4>Questo rifiuto non è visto come nulla di personale. Tu sei libero di cambiare idea riguardo gli oggetti di cui decidi di liberarti e regalare.</h4>
            <h4>Nulla deve essere forzato, ROBA è creata per aiutarsi e contribuire insieme a ridurre gli sprechi.</h4>

            <div className="confirm-request-modal-button">
              <button onClick={declineRequest}>Rifiuto la richiesta</button>
              <button onClick={closeDeclineModal}>Torna indietro</button>
            </div>
          </div>

        }

        {
          isDeclinedRequest &&

          <h2> Hai rifiutato la richiesta per questo oggetto.</h2>
        }
      </div>
      {isFetchPending && <LoaderModal isFetchPending={isFetchPending}/>}
    </div>
  )
}

export default UserObjectBox;
